export default "__VITE_ASSET__ce07729d__"